<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-gray-800 pt-6">
    <div class="flex flex-col items-center justify-center mb-4">
      <input
        v-model="searchTerm"
        type="text"
        placeholder="Szukaj po nazwie, kategorii lub opisie..."
        class="w-full max-w-xl text-lg rounded-full border border-gray-700 py-3 px-6 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-800 text-gray-100 placeholder-gray-400 mb-2"
      />
    </div>

    <div class="sm:flex sm:items-center mb-4">
      <div class="sm:flex-auto text-left">
        <h1 class="text-xl font-semibold text-white">
          Zarządzanie Tagami ({{ filteredTags.length }} / {{ tags.length }})
        </h1>
        <p class="mt-2 text-sm text-gray-400">
          Dodawaj i zarządzaj tagami, które będą dostępne w autouzupełnianiu
          przy edycji lokali.
        </p>
      </div>
      <div class="mt-4 sm:mt-0 sm:ml-4 sm:flex-none flex items-center space-x-2">
        <div class="relative inline-block text-left">
          <button
            @click="dropdownOpen = !dropdownOpen"
            type="button"
            class="inline-flex items-center justify-center rounded-full h-12 w-12 text-gray-400 bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
            id="menu-button"
            aria-expanded="true"
            aria-haspopup="true"
          >
            <span class="sr-only">Open options</span>
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
              />
            </svg>
          </button>

          <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <div
              v-if="dropdownOpen"
              v-click-away="() => (dropdownOpen = false)"
              class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-gray-700 ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabindex="-1"
            >
              <div class="py-1" role="none">
                <a
                  href="#"
                  @click.prevent="recountTagsUsage"
                  class="text-white block px-4 py-2 text-sm hover:bg-gray-600"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-item-0"
                  >🔄 Przelicz użycia</a
                >
                <a
                  href="#"
                  @click.prevent="exportTags"
                  class="text-white block px-4 py-2 text-sm hover:bg-gray-600"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-item-1"
                  >📥 Eksportuj CSV</a
                >
                <a
                  href="#"
                  @click.prevent="showBulkForm = true"
                  class="text-white block px-4 py-2 text-sm hover:bg-gray-600"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-item-2"
                  >📦 Import hurtowy</a
                >
              </div>
            </div>
          </transition>
        </div>
        <button
          @click="showAddForm = true"
          type="button"
          class="inline-flex items-center justify-center rounded-full border border-transparent bg-indigo-700 px-6 py-4 text-sm font-bold text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto"
        >
          + dodaj tag
        </button>
      </div>
    </div>

    <!-- Formularz dodawania -->
    <div v-if="showAddForm" class="mx-auto bg-gray-700 text-white p-6 rounded-lg shadow-md mt-5 mb-8">
      <h2 class="text-2xl font-bold mb-6">Dodaj nowy tag</h2>
      <form @submit.prevent="addTag" class="space-y-4">
        <div class="flex flex-wrap gap-4">
          <div class="flex-1 min-w-0">
            <label for="name" class="block text-sm font-medium text-white">Nazwa tagu *</label>
            <input
              type="text"
              id="name"
              v-model="newTag.name"
              placeholder="np. kebab, pizza, sushi"
              class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              required
            />
          </div>
          <div class="flex-1 min-w-0">
            <label for="icon" class="block text-sm font-medium text-white"
              >Ikona (emoji lub URL)</label
            >
            <input
              type="text"
              id="icon"
              v-model="newTag.icon"
              placeholder="🍕 lub /icons/pizza.svg"
              class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <div class="flex-1 min-w-0">
            <label for="category" class="block text-sm font-medium text-white">Kategoria</label>
            <select id="category" v-model="newTag.category" class="mt-1 block w-full px-3 py-2 border text-white border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
              <option value="">Wybierz kategorię</option>
              <option value="kuchnia">Kuchnia</option>
              <option value="typ">Typ lokalu</option>
              <option value="cecha">Cecha</option>
              <option value="lokalizacja">Lokalizacja</option>
              <option value="inne">Inne</option>
            </select>
          </div>
        </div>
        <div class="w-full">
          <label for="description" class="block text-sm font-medium text-white">Opis (opcjonalny)</label>
          <textarea
            id="description"
            v-model="newTag.description"
            rows="2"
            placeholder="Krótki opis tagu..."
            class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          ></textarea>
        </div>
        <div class="flex justify-end space-x-3">
          <button
            @click="cancelAdd"
            type="button"
            class="px-4 py-2 bg-gray-500 text-white font-semibold rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Anuluj
          </button>
          <button
            type="submit"
            class="px-4 py-2 bg-blue-500 text-white font-semibold rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
            :disabled="isAdding"
          >
            {{ isAdding ? 'Dodawanie...' : 'Dodaj' }}
          </button>
        </div>
      </form>
    </div>

    <!-- Formularz importu hurtowego -->
    <div v-if="showBulkForm" class="mx-auto bg-gray-700 text-white p-6 rounded-lg shadow-md mt-5 mb-8">
      <h2 class="text-2xl font-bold mb-6">Import hurtowy tagów</h2>
      
      <!-- Opcje importu -->
      <div class="mb-6">
        <div class="flex space-x-4 mb-4">
          <button 
            @click="importMethod = 'text'"
            :class="[
              'px-4 py-2 rounded-md font-medium',
              importMethod === 'text' 
                ? 'bg-blue-600 text-white' 
                : 'bg-gray-600 text-gray-300 hover:bg-gray-500'
            ]"
          >
            📝 Wklej tekst
          </button>
          <button 
            @click="importMethod = 'file'"
            :class="[
              'px-4 py-2 rounded-md font-medium',
              importMethod === 'file' 
                ? 'bg-blue-600 text-white' 
                : 'bg-gray-600 text-gray-300 hover:bg-gray-500'
            ]"
          >
            📁 Wybierz plik CSV
          </button>
        </div>
      </div>

      <!-- Import z tekstu -->
      <div v-if="importMethod === 'text'" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-white mb-2">Wklej tagi (jeden na linię lub oddzielone przecinkami)</label>
          <textarea
            v-model="bulkTagsText"
            rows="10"
            placeholder="Przykład:
kebab
pizza
sushi
burger
kawa
herbata

Lub w jednej linii: kebab, pizza, sushi, burger, kawa, herbata"
            class="block w-full px-3 py-2 border text-white border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          ></textarea>
        </div>
        
        <div class="flex flex-wrap gap-4">
          <div class="flex-1 min-w-0">
            <label for="bulkCategory" class="block text-sm font-medium text-white">Kategoria dla wszystkich tagów</label>
            <select id="bulkCategory" v-model="bulkCategory" class="mt-1 block w-full px-3 py-2 border text-white border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
              <option value="">Wybierz kategorię</option>
              <option value="kuchnia">Kuchnia</option>
              <option value="typ">Typ lokalu</option>
              <option value="cecha">Cecha</option>
              <option value="lokalizacja">Lokalizacja</option>
              <option value="inne">Inne</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Import z pliku -->
      <div v-if="importMethod === 'file'" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-white mb-2">Wybierz plik CSV</label>
          <input
            type="file"
            @change="handleFileUpload"
            accept=".csv,.txt"
            class="block w-full text-sm text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          />
          <p class="text-xs text-gray-400 mt-1">Format CSV: nazwa,kategoria,opis (opcjonalnie)</p>
        </div>
      </div>

      <!-- Podgląd tagów do importu -->
      <div v-if="tagsToImport.length > 0" class="mt-6">
        <h3 class="text-lg font-medium text-white mb-3">Tagów do importu: {{ tagsToImport.length }}</h3>
        <div class="bg-gray-800 p-4 rounded-md max-h-40 overflow-y-auto">
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            <div 
              v-for="(tag, index) in tagsToImport" 
              :key="index"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
            >
              {{ tag.name }}
              <span v-if="tag.category" class="ml-1 text-xs text-gray-500">({{ tag.category }})</span>
            </div>
          </div>
        </div>
        <p class="text-sm text-gray-400 mt-2">
          Duplikaty zostały automatycznie odfiltrowane. Importowane będą tylko nowe tagi.
        </p>
      </div>

      <!-- Przyciski akcji -->
      <div class="flex justify-end space-x-3 mt-6">
        <button
          @click="cancelBulkForm"
          type="button"
          class="px-4 py-2 bg-gray-500 text-white font-semibold rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          Anuluj
        </button>
        <button
          @click="processBulkImport"
          type="button"
          class="px-4 py-2 bg-green-500 text-white font-semibold rounded-md shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
          :disabled="isImporting || tagsToImport.length === 0"
        >
          {{ isImporting ? 'Importowanie...' : `Importuj ${tagsToImport.length} tagów` }}
        </button>
      </div>
    </div>

    <!-- Lista tagów -->
    <div class="mt-8 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div
            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
          >
            <table class="min-w-full divide-y divide-gray-700">
              <thead class="bg-gray-700">
                <tr>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-6"
                  >
                    <a href="#" class="group inline-flex" @click.prevent="sortBy('id')">
                      ID
                      <span
                        class="ml-2 flex-none rounded text-gray-400"
                        :class="{ 'invisible': !sortState.id.active }"
                      >
                        <ChevronUpIcon
                          class="h-5 w-5"
                          v-if="!sortState.id.ascending"
                        />
                        <ChevronDownIcon
                          class="h-5 w-5"
                          v-if="sortState.id.ascending"
                        />
                      </span>
                    </a>
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                  >
                    <a href="#" class="group inline-flex" @click.prevent="sortBy('name')">
                      Nazwa
                      <span
                        class="ml-2 flex-none rounded text-gray-400"
                        :class="{ 'invisible': !sortState.name.active }"
                      >
                        <ChevronUpIcon
                          class="h-5 w-5"
                          v-if="!sortState.name.ascending"
                        />
                        <ChevronDownIcon
                          class="h-5 w-5"
                          v-if="sortState.name.ascending"
                        />
                      </span>
                    </a>
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                  >
                    Ikona
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                  >
                    <a href="#" class="group inline-flex" @click.prevent="sortBy('category')">
                      Kategoria
                      <span
                        class="ml-2 flex-none rounded text-gray-400"
                        :class="{ 'invisible': !sortState.category.active }"
                      >
                        <ChevronUpIcon
                          class="h-5 w-5"
                          v-if="!sortState.category.ascending"
                        />
                        <ChevronDownIcon
                          class="h-5 w-5"
                          v-if="sortState.category.ascending"
                        />
                      </span>
                    </a>
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                  >
                    Opis
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                  >
                    <a href="#" class="group inline-flex" @click.prevent="sortBy('kolejnosc')">
                      Kolejność
                      <span
                        class="ml-2 flex-none rounded text-gray-400"
                        :class="{ 'invisible': !sortState.kolejnosc.active }"
                      >
                        <ChevronUpIcon
                          class="h-5 w-5"
                          v-if="!sortState.kolejnosc.ascending"
                        />
                        <ChevronDownIcon
                          class="h-5 w-5"
                          v-if="sortState.kolejnosc.ascending"
                        />
                      </span>
                    </a>
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                  >
                    <a href="#" class="group inline-flex" @click.prevent="sortBy('usage_count')">
                      Użycia
                      <span
                        class="ml-2 flex-none rounded text-gray-400"
                        :class="{ 'invisible': !sortState.usage_count.active }"
                      >
                        <ChevronUpIcon
                          class="h-5 w-5"
                          v-if="!sortState.usage_count.ascending"
                        />
                        <ChevronDownIcon
                          class="h-5 w-5"
                          v-if="sortState.usage_count.ascending"
                        />
                      </span>
                    </a>
                  </th>
                  <th
                    scope="col"
                    class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                  >
                    <span class="sr-only">Akcje</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-700 bg-gray-800">
                <tr
                  v-for="tag in filteredTags"
                  :key="tag.id"
                  class="hover:bg-gray-700 transition-colors cursor-pointer"
                  @click="openEditModal(tag)"
                >
                  <td
                    class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-white sm:pl-6"
                  >
                    {{ tag.id }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-400">
                    {{ tag.name }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-400">
                    {{ tag.icon }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-400">
                    {{ tag.category }}
                  </td>
                  <td class="px-3 py-4 text-sm text-gray-400">
                    <div class="max-w-xs truncate" :title="tag.description">
                      {{ tag.description }}
                    </div>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-400">
                    {{ tag.kolejnosc || 0 }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-400">
                    {{ tag.usage_count || 0 }}
                  </td>
                  <td
                    class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                  >
                    <button
                      @click.stop="deleteTag(tag.id)"
                      class="text-red-400 hover:text-red-300 bg-gray-800 hover:bg-gray-600 px-3 py-1 rounded-full"
                      :disabled="isDeleting === tag.id"
                    >
                      {{ isDeleting === tag.id ? "Usuwanie..." : "Usuń" }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <div
      v-if="showEditModal"
      class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
    >
      <div
        class="bg-gray-700 text-white p-6 rounded-lg shadow-xl w-full max-w-lg"
      >
        <h2 class="text-2xl font-bold mb-6">Edytuj tag</h2>
        <form @submit.prevent="updateTag" class="space-y-4">
          <div>
            <label
              for="edit-name"
              class="block text-sm font-medium text-white"
              >Nazwa tagu *</label
            >
            <input
              type="text"
              id="edit-name"
              v-model="editingTag.name"
              class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              required
            />
          </div>
          <div>
            <label
              for="edit-icon"
              class="block text-sm font-medium text-white"
              >Ikona (emoji lub URL)</label
            >
            <input
              type="text"
              id="edit-icon"
              v-model="editingTag.icon"
              class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <div>
            <label
              for="edit-category"
              class="block text-sm font-medium text-white"
              >Kategoria</label
            >
            <select
              id="edit-category"
              v-model="editingTag.category"
              class="mt-1 block w-full px-3 py-2 border text-white border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              <option value="">Wybierz kategorię</option>
              <option value="kuchnia">Kuchnia</option>
              <option value="typ">Typ lokalu</option>
              <option value="cecha">Cecha</option>
              <option value="lokalizacja">Lokalizacja</option>
              <option value="inne">Inne</option>
            </select>
          </div>
          <div>
            <label
              for="edit-description"
              class="block text-sm font-medium text-white"
              >Opis (opcjonalny)</label
            >
            <textarea
              id="edit-description"
              v-model="editingTag.description"
              rows="3"
              class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            ></textarea>
          </div>
          <div>
            <label
              for="edit-kolejnosc"
              class="block text-sm font-medium text-white"
              >Kolejność</label
            >
            <input
              type="number"
              id="edit-kolejnosc"
              v-model="editingTag.kolejnosc"
              class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <div class="flex justify-end space-x-3 pt-4">
            <button
              @click="closeEditModal"
              type="button"
              class="px-4 py-2 bg-gray-500 text-white font-semibold rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400"
            >
              Anuluj
            </button>
            <button
              type="submit"
              class="px-4 py-2 bg-blue-500 text-white font-semibold rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
              :disabled="isUpdating"
            >
              {{ isUpdating ? "Zapisywanie..." : "Zapisz zmiany" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, reactive, computed } from "vue";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/20/solid";
import { directive as vClickAway } from "vue3-click-away";
import { apiFetch } from "@/composables/apiClient";

const tags = ref([]);
const showAddForm = ref(false);
const showBulkForm = ref(false);
const isAdding = ref(false);
const isDeleting = ref(null);
const isImporting = ref(false);
const tagsLoaded = ref(false);
const isRecounting = ref(false);
const dropdownOpen = ref(false);

const searchTerm = ref("");

const sortState = reactive({
  id: { ascending: true, active: true },
  name: { ascending: true, active: false },
  category: { ascending: true, active: false },
  kolejnosc: { ascending: true, active: false },
  usage_count: { ascending: true, active: false },
});

const showEditModal = ref(false);
const isUpdating = ref(false);
const editingTag = ref(null);

// Bulk import variables
const importMethod = ref("text");
const bulkTagsText = ref("");
const bulkCategory = ref("");
const tagsToImport = ref([]);

const newTag = ref({
  name: "",
  category: "",
  description: "",
  icon: "",
});

// Pobieranie tagów
const fetchTags = async () => {
  try {
    const response = await apiFetch('/api/tags');
    if (response.ok) {
      const data = await response.json();
      tags.value = data.data;
      tagsLoaded.value = true; // Set flag to true after data is loaded
    } else {
      console.error('Błąd podczas pobierania tagów');
    }
  } catch (error) {
    console.error('Błąd:', error);
  }
};

// Dodawanie tagu
const addTag = async () => {
  isAdding.value = true;
  try {
    const response = await apiFetch('/api/tags', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newTag.value),
    });
    
    if (response.ok) {
      const data = await response.json();
      tags.value.push(data.data);
      cancelAdd();
      console.log('Tag dodany pomyślnie!');
    } else {
      console.error('Błąd podczas dodawania tagu');
    }
  } catch (error) {
    console.error('Błąd:', error);
  } finally {
    isAdding.value = false;
  }
};

const sortBy = (key) => {
  Object.keys(sortState).forEach((k) => (sortState[k].active = false));

  sortState[key].active = true;
  sortState[key].ascending = !sortState[key].ascending;

  tags.value.sort((a, b) => {
    let valA = a[key] === null || a[key] === undefined ? '' : a[key];
    let valB = b[key] === null || b[key] === undefined ? '' : b[key];

    if (typeof valA === 'number' && typeof valB === 'number') {
      return sortState[key].ascending ? valA - valB : valB - valA;
    }

    if (typeof valA === 'string' && typeof valB === 'string') {
      return sortState[key].ascending
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    }
    
    // Fallback for mixed types or other types
    if (valA < valB) return sortState[key].ascending ? -1 : 1;
    if (valA > valB) return sortState[key].ascending ? 1 : -1;
    return 0;
  });
};

const filteredTags = computed(() => {
  if (!searchTerm.value) return tags.value;
  const term = searchTerm.value.toLowerCase();
  return tags.value.filter(
    (tag) =>
      (tag.name && tag.name.toLowerCase().includes(term)) ||
      (tag.category && tag.category.toLowerCase().includes(term)) ||
      (tag.description && tag.description.toLowerCase().includes(term))
  );
});

const recountTagsUsage = async () => {
  if (
    !confirm(
      "Czy na pewno chcesz przeliczyć użycia wszystkich tagów? Może to chwilę potrwać."
    )
  )
    return;

  isRecounting.value = true;
  try {
    const response = await apiFetch(
      '/api/tags/recount',
      {
        method: "POST",
      }
    );

    if (response.ok) {
      alert("Przeliczanie zakończone pomyślnie. Odświeżanie listy...");
      await fetchTags();
    } else {
      const errorText = await response.text();
      console.error(
        "Błąd podczas przeliczania tagów. Status:",
        response.status,
        "Treść:",
        errorText
      );
      alert("Wystąpił błąd podczas przeliczania użycia tagów.");
    }
  } catch (error) {
    console.error("Błąd:", error);
    alert("Wystąpił krytyczny błąd podczas komunikacji z serwerem.");
  } finally {
    isRecounting.value = false;
  }
};

const openEditModal = (tag) => {
  editingTag.value = JSON.parse(JSON.stringify(tag));
  showEditModal.value = true;
};

const closeEditModal = () => {
  showEditModal.value = false;
  editingTag.value = null;
};

const updateTag = async () => {
  if (!editingTag.value) return;

  isUpdating.value = true;
  try {
    const tagData = {
      name: editingTag.value.name,
      category: editingTag.value.category,
      description: editingTag.value.description,
      kolejnosc: editingTag.value.kolejnosc,
      icon: editingTag.value.icon,
    };

    const response = await apiFetch(
      `/api/tags/${editingTag.value.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tagData),
      }
    );

    if (response.ok) {
      console.log("Tag zaktualizowany pomyślnie! Odświeżanie listy...");
      await fetchTags();
      closeEditModal();
    } else {
      const errorText = await response.text();
      console.error(
        "Błąd podczas aktualizacji tagu. Status:",
        response.status,
        "Treść:",
        errorText
      );

      if (errorText.includes("duplicate key value")) {
        alert("Błąd: Taka nazwa tagu już istnieje. Proszę wybrać inną.");
      } else {
        alert(
          "Wystąpił błąd podczas aktualizacji tagu. Sprawdź konsolę, aby uzyskać więcej informacji."
        );
      }
    }
  } catch (error) {
    console.error("Błąd:", error);
  } finally {
    isUpdating.value = false;
  }
};

// Usuwanie tagu
const deleteTag = async (id) => {
  if (!confirm('Czy na pewno chcesz usunąć ten tag?')) return;
  
  isDeleting.value = id;
  try {
    const response = await apiFetch(`/api/tags/${id}`, {
      method: 'DELETE',
    });
    
    if (response.ok) {
      tags.value = tags.value.filter(tag => tag.id !== id);
      console.log('Tag usunięty pomyślnie!');
    } else {
      console.error('Błąd podczas usuwania tagu');
    }
  } catch (error) {
    console.error('Błąd:', error);
  } finally {
    isDeleting.value = null;
  }
};

// Anulowanie dodawania
const cancelAdd = () => {
  showAddForm.value = false;
  newTag.value = {
    name: "",
    category: "",
    description: "",
    icon: "",
  };
};

// Obsługa importu pliku
const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      parseCSV(content);
    };
    reader.readAsText(file);
  }
};

// Parsowanie CSV
const parseCSV = (content) => {
  const lines = content.split('\n');
  const headers = lines[0].split(',').map(h => h.trim());
  const data = [];

  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(',').map(v => v.trim());
    if (values.length === headers.length) {
      const tag = {
        name: values[0],
        category: values[1],
        description: values[2] || ''
      };
      data.push(tag);
    }
  }
  tagsToImport.value = data;
};

// Proces importu hurtowego
const processBulkImport = async () => {
  isImporting.value = true;
  try {
    const response = await apiFetch('/api/tags/bulk', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tags: tagsToImport.value,
        category: bulkCategory.value
      }),
    });

    if (response.ok) {
      const data = await response.json();
      tags.value = data.data;
      cancelBulkForm();
      console.log('Tagi importowane pomyślnie!');
    } else {
      console.error('Błąd podczas importowania tagów');
    }
  } catch (error) {
    console.error('Błąd:', error);
  } finally {
    isImporting.value = false;
  }
};

// Anulowanie importu hurtowego
const cancelBulkForm = () => {
  showBulkForm.value = false;
  importMethod.value = 'text';
  bulkTagsText.value = '';
  bulkCategory.value = '';
  tagsToImport.value = [];
};

// Watcher dla tekstu importu
watch(bulkTagsText, (newValue) => {
  if (!newValue || !tagsLoaded.value) {
    tagsToImport.value = [];
    return;
  }

  // Parsowanie tekstu - obsługuje zarówno linie jak i przecinki
  const lines = newValue.split('\n');
  const tags = [];
  const existingTagNames = (tags.value || []).map(tag => tag.name.toLowerCase());
  
  for (const line of lines) {
    const trimmedLine = line.trim();
    if (trimmedLine) {
      // Sprawdź czy linia zawiera przecinki (format CSV)
      if (trimmedLine.includes(',')) {
        const parts = trimmedLine.split(',').map(part => part.trim());
        const tagName = parts[0];
        
        // Sprawdź czy tag już istnieje
        if (!existingTagNames.includes(tagName.toLowerCase())) {
          tags.push({
            name: tagName,
            category: parts[1] || bulkCategory.value,
            description: parts[2] || ''
          });
        }
      } else {
        // Pojedynczy tag w linii
        const tagName = trimmedLine;
        
        // Sprawdź czy tag już istnieje
        if (!existingTagNames.includes(tagName.toLowerCase())) {
          tags.push({
            name: tagName,
            category: bulkCategory.value,
            description: ''
          });
        }
      }
    }
  }
  
  tagsToImport.value = tags;
}, { deep: true }); // Add deep: true to watch for nested changes

// Watcher dla kategorii hurtowej
watch(bulkCategory, (newValue) => {
  // Aktualizuj kategorię dla wszystkich tagów w import
  tagsToImport.value.forEach(tag => {
    if (!tag.category) {
      tag.category = newValue;
    }
  });
});

// Watcher dla tags - aktualizuj listę importowanych tagów gdy dane się zmienią
watch(tags, () => {
  if (bulkTagsText.value && tagsLoaded.value) {
    // Re-trigger the bulkTagsText watcher to update the import list
    const currentText = bulkTagsText.value;
    bulkTagsText.value = '';
    bulkTagsText.value = currentText;
  }
}, { deep: true });

// Funkcja do eksportu tagów do CSV
const exportTags = () => {
  const csvContent = [
    ['ID', 'Nazwa', 'Kategoria', 'Opis', 'Użycia'],
    ...tags.value.map(tag => [
      tag.id,
      tag.name,
      tag.category,
      tag.description,
      tag.usage_count || 0
    ])
  ];

  const csvString = csvContent.map(row => row.join(',')).join('\n');
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'tags.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

onMounted(() => {
  fetchTags();
});
</script> 